import { buildModelManager } from "../builder.js";
const DefaultMemoryItemV2Selection = {
  __typename: true,
  id: true,
  createdAt: true,
  embedding: true,
  tags: true,
  text: { markdown: true, truncatedHTML: true },
  updatedAt: true,
  userId: true,
  vectorId: true
};
const modelApiIdentifier = "memoryItemV2";
const pluralModelApiIdentifier = "memoryItemV2s";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMemoryItemV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMemoryItemV2Selection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMemoryItemV2Selection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMemoryItemV2Selection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMemoryItemV2Selection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMemoryItemV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMemoryItemV2Selection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createMemoryItemV2",
    operationReturnType: "CreateMemoryItemV2",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      memoryItemV2: { required: false, type: "CreateMemoryItemV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMemoryItemV2Selection
  },
  {
    type: "action",
    operationName: "bulkCreateMemoryItemV2s",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateMemoryItemV2sInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultMemoryItemV2Selection
  },
  {
    type: "action",
    operationName: "updateMemoryItemV2",
    operationReturnType: "UpdateMemoryItemV2",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      memoryItemV2: { required: false, type: "UpdateMemoryItemV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMemoryItemV2Selection
  },
  {
    type: "action",
    operationName: "bulkUpdateMemoryItemV2s",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateMemoryItemV2sInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultMemoryItemV2Selection
  },
  {
    type: "action",
    operationName: "deleteMemoryItemV2",
    operationReturnType: "DeleteMemoryItemV2",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteMemoryItemV2s",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertMemoryItemV2",
    operationReturnType: "UpsertMemoryItemV2",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      memoryItemV2: { required: false, type: "UpsertMemoryItemV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateMemoryItemV2Result": { hasReturnType: false },
      "... on UpdateMemoryItemV2Result": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMemoryItemV2Selection
  },
  {
    type: "action",
    operationName: "bulkUpsertMemoryItemV2s",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertMemoryItemV2sInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultMemoryItemV2Selection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "memoryItemV2GellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const MemoryItemV2Manager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultMemoryItemV2Selection,
  operations
);
export {
  DefaultMemoryItemV2Selection,
  MemoryItemV2Manager
};
//# sourceMappingURL=MemoryItemV2.js.map
